import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { sendLoginPepsiSSO } from '../../actions/userActions';
import { withRouter } from '../../actions/withRouterHook';

function CallbackPepsiSSOContainer(props) {
    let navigate = useNavigate();
    let location = useLocation();

    // trigger on component mount
    // TODO: Look up to make sure [location.search] is the correct thing to use since we are using react hooks now
    useEffect(() => {
        if (props.loggedIn === true || props.ssoFail) {
            navigate("/");
        } else if (props.ssoFlag) {
            let urlParams = new URLSearchParams(location.search);
            let jtoken = urlParams.get("jtoken");
            props.sendLoginPepsiSSO(jtoken);
        }
    });

    if (!props.loggedIn) {
        return <div className="blank" style={{backgroundColor: "white"}}></div>;
    } else {
        navigate("/");
    }
}

function mapStateToProps(state) {
    return {
        loggedIn: state.users.loggedIn,
        ssoFail: state.users.ssoFail,
        ssoFlag: state.users.ssoFlag,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators({ sendLoginPepsiSSO }, dispatch)
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CallbackPepsiSSOContainer))